export default __webpack_public_path__ + "static/media/TXT.d9a1c901.png";